<script lang="ts">
	import NotificationIcon from './notifications/NotificationIcon.svelte';
	import ComposeIcon from '$lib/components/headerBar/composeMenu/ComposeIcon.svelte';
	import SettingsIcon from '$lib/components/headerBar/settingsMenu/settingsIcon.svelte';
	import AccountMenu from '$lib/components/headerBar/accountMenu/AccountMenu.svelte';
	import PerformanceIcon from '$lib/components/headerBar/performance/PerformanceIcon.svelte';
	import { atLeastCollaborator } from '$lib/utils/roles';
	import type { Writable } from 'svelte/store';
	import type { Hub } from '$lib/api/rpc';

	export let hub: Writable<Hub>;
</script>

<div>
	{#if $hub.settings.allow_member_submissions || atLeastCollaborator($hub.user_context)}
		<ComposeIcon {hub} />
	{/if}
	{#if $hub.user_context.perms.posts.view_metrics}
		<PerformanceIcon {hub} />
	{/if}
	{#if $hub.user_context.perms.hub_settings.manage}
		<SettingsIcon {hub} />
	{/if}
	<NotificationIcon {hub} />
	<AccountMenu />
</div>

<style>
	div {
		display: flex;
		gap: var(--gutterMedium);
		align-items: center;
		justify-content: flex-end;
		inline-size: 168px;
	}
</style>
